import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';

/**
 * Google Cloud Pub/Sub icon
 * @see https://cloud.google.com/icons
 */
export function GCPPubSubLightIcon() {
  const $ = _c(18);
  const mask_id = useId();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <circle cx="12" cy="12.23" r="3.58" fill="#fff" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== mask_id) {
    t1 = <defs><mask id={mask_id} x="4.64" y="4.19" width="14.73" height="12.76" maskUnits="userSpaceOnUse">{t0}</mask></defs>;
    $[1] = mask_id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <circle cx="18.97" cy="8.21" r="1.72" fill="#669df6" />;
    t3 = <circle cx="5.03" cy="8.21" r="1.72" fill="#669df6" />;
    t4 = <circle cx="12" cy="20.28" r="1.72" fill="#669df6" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  const t5 = `url(#${mask_id})`;
  let t6;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <rect x="14.69" y="10.22" width="1.59" height="8.04" transform="matrix(0.5, -0.87, 0.87, 0.5, -4.59, 20.53)" fill="#4285f4" />;
    t7 = <rect x="4.49" y="13.45" width="8.04" height="1.59" transform="translate(-5.98 6.17) rotate(-30)" fill="#4285f4" />;
    t8 = <rect x="11.2" y="4.19" width="1.59" height="8.04" fill="#4285f4" />;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t5) {
    t9 = <g mask={t5}>{t6}{t7}{t8}</g>;
    $[9] = t5;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <circle cx="12" cy="12.23" r="2.78" fill="#aecbfa" />;
    t11 = <circle cx="5.03" cy="16.25" r="2.19" fill="#aecbfa" />;
    t12 = <circle cx="18.97" cy="16.25" r="2.19" fill="#aecbfa" />;
    t13 = <circle cx="12" cy="4.19" r="2.19" fill="#aecbfa" />;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t13;
  } else {
    t10 = $[11];
    t11 = $[12];
    t12 = $[13];
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t1 || $[16] !== t9) {
    t14 = <svg height="16" width="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t1}{t2}{t3}{t4}{t9}{t10}{t11}{t12}{t13}</svg>;
    $[15] = t1;
    $[16] = t9;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  return t14;
}